'use strict';

var isIe = require('@braintree/browser-detection/is-ie');
var isIe9 = require('@braintree/browser-detection/is-ie9');

module.exports = {
  isIe: isIe,
  isIe9: isIe9
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/braintree-web/client/browser-detection.js
// module id = 1004
// module chunks = 0